import type { DomainOrganizationalUnit } from "@exopengithub/planning-api-shared";
import { createEntityAdapter } from "@reduxjs/toolkit";

export const organizationalUnitsAdapter =
	createEntityAdapter<DomainOrganizationalUnit>();

export const organizationalUnitsSelectors =
	organizationalUnitsAdapter.getSelectors();
